declare type LocalDate = string

export function consistentPeriod(dtInicial: LocalDate, dtFinal: LocalDate) {
  if (!(dtInicial && dtFinal)) {
    return null
  }

  if (dtInicial.valueOf() > dtFinal.valueOf()) {
    return 'A Data inicial não pode ser posterior a Data final.'
  }
}
